import $ from 'jquery';

$('.user_menu__item_accessability').each(function() {
    $(this).on('click', () => {
        const body = $('body');
        const body_classes = body.hasClass('is-accessability');
        const logoSrc = $('.logo__link img').attr('data-src-white');
        if (body_classes) {
            localStorage.removeItem('is_visually_impaired');
            window.location.reload();
        } else {
            localStorage.setItem('is_visually_impaired', true);
            localStorage.setItem('background_color', 'white');
            localStorage.setItem('font-size', '1.0');
            localStorage.setItem('font-family', 'sans-serif');
            localStorage.setItem('font-family', 'sans-serif');
            localStorage.setItem('letter-spacing', 'sm');
            localStorage.setItem('line-spacing', 'sm');
            body.addClass('is-accessability');
            body.addClass('white-accessability');
            body.addClass('sans-serif-font');
            body.addClass('font-size-100');
            body.addClass('letter-spacing-sm');
            body.addClass('line-spacing-sm');

            $('.logo__link img').attr('src', logoSrc);
            $('.get_apps__link_android img').attr('src', '/static/img/svg/google_play_bw.svg');
            $('.get_apps__link_ios img').attr('src', '/static/img/svg/app_store_bw.svg');
        }
    });
});

// Цвет фона сайта
$('.site-color a').on('click', (e) => {
    const target = $(e.target);
    const body = $('body');

    if (target.hasClass('site-color__item_wb')) {
        const logoSrc = $('.logo__link img').attr('data-src-white');
        localStorage.setItem('background_color', 'white');
        body.removeClass('black-accessability');
        body.removeClass('blue-accessability');
        body.addClass('white-accessability');
        $('.logo__link img').attr('src', logoSrc);
        $('.get_apps__link_android img').attr('src', '/static/img/svg/google_play_bw.svg');
        $('.get_apps__link_ios img').attr('src', '/static/img/svg/app_store_bw.svg');
    } else if (target.hasClass('site-color__item_bw')) {
        const logoSrc = $('.logo__link img').attr('data-src-black');
        localStorage.setItem('background_color', 'black');
        body.removeClass('white-accessability');
        body.removeClass('blue-accessability');
        body.addClass('black-accessability');
        $('.logo__link img').attr('src', logoSrc);
        $('.get_apps__link_android img').attr('src', '/static/img/svg/google_play_wb.svg');
        $('.get_apps__link_ios img').attr('src', '/static/img/svg/app_store_wb.svg');
    } else if (target.hasClass('site-color__item_bb')) {
        const logoSrc = $('.logo__link img').attr('data-src-blue');
        localStorage.setItem('background_color', 'blue');
        body.removeClass('white-accessability');
        body.removeClass('black-accessability');
        body.addClass('blue-accessability');
        $('.logo__link img').attr('src', logoSrc);
        $('.get_apps__link_android img').attr('src', '/static/img/svg/google_play_bb.svg');
        $('.get_apps__link_ios img').attr('src', '/static/img/svg/app_store_bb.svg');
    }
});

const setFontSize = (item, font_size) => {
    let inHTML = item.innerHTML.replaceAll('&nbsp;', ' ');
    inHTML = inHTML.replaceAll('<strong>', ' ');
    inHTML = inHTML.replaceAll('</strong>', ' ');
    inHTML = inHTML.replaceAll('<nobr>', ' ');
    inHTML = inHTML.replaceAll('</nobr>', ' ');
    inHTML = inHTML.replaceAll('<sup>', ' ');
    inHTML = inHTML.replaceAll('</sup>', ' ');
    inHTML = inHTML.replaceAll('<br>', ' ');
    inHTML = inHTML.replaceAll(' ', '');
    let inText = item.innerText.replaceAll(' ', ' ');
    inText = inText.replaceAll(' ', '');
    if (inText.trim() !== inHTML.trim()) return;
    item.setAttribute('style', 'font-size:' + font_size + 'px' + '!important');
};

export const nullFontSize = (selector) => {
    if (selector) {
    }
    const k = parseFloat(localStorage.getItem('font-size'));
    const tags = selector
        ? document
              .querySelector(selector)
              .querySelectorAll(
                  'h1, h2, h3, h4, h5, h6, p, a, address, time, span, th, td, li, button, input, label, strong, option, textarea'
              )
        : document.querySelectorAll(
              'h1, h2, h3, h4, h5, h6, p, a, address, time, span, th, td, li, button, input, label, strong, option, textarea'
          );

    tags.forEach((item) => {
        let inHTML = item.innerHTML.replaceAll('&nbsp;', ' ');
        inHTML = inHTML.replaceAll('<strong>', ' ');
        inHTML = inHTML.replaceAll('</strong>', ' ');
        inHTML = inHTML.replaceAll('<nobr>', ' ');
        inHTML = inHTML.replaceAll('</nobr>', ' ');
        inHTML = inHTML.replaceAll(' ', '');
        let inText = item.innerText.replaceAll(' ', ' ');
        inText = inText.replaceAll(' ', '');
        if (inText.trim() !== inHTML.trim()) return;
        item.removeAttribute('style');
    });
};

const changeFontSize = (size) => {
    const k = parseFloat(localStorage.getItem('font-size'));
    if (k !== size) {
        const tags = document.querySelectorAll(
            'h1, h2, h3, h4, h5, h6, p, a, address, time, span, th, td, li, button, input, label, strong, option, textarea'
        );
        if (k === 1.0) {
            tags.forEach((item) => {
                if (
                    !item.closest('.layout--privacy-policy') &&
                    !item.closest('.question_answer__answer') &&
                    !item.closest('.specialist_profile__biography') &&
                    !item.classList.contains('contacts_block__phone') &&
                    !item.classList.contains('attention__license')
                ) {
                    const current_font_sz = window.getComputedStyle(item).fontSize.replace('px', '');
                    const new_font_sz = current_font_sz * size;
                    setFontSize(item, new_font_sz);
                }
            });
        } else {
            tags.forEach((item) => {
                if (
                    !item.closest('.layout--privacy-policy') &&
                    !item.closest('.question_answer__answer') &&
                    !item.closest('.specialist_profile__biography') &&
                    !item.classList.contains('contacts_block__phone') &&
                    !item.classList.contains('attention__license')
                ) {
                    const current_font_sz = window.getComputedStyle(item).fontSize.replace('px', '');
                    const new_font_sz = (current_font_sz / k) * size;
                    setFontSize(item, new_font_sz);
                }
            });
        }

        localStorage.setItem('font-size', size);
    }
};

export const calcFontSize = (selector) => {
    const k = parseFloat(localStorage.getItem('font-size'));
    const tags = selector
        ? document
              .querySelector(selector)
              .querySelectorAll(
                  'h1, h2, h3, h4, h5, h6, p, a, address, time, span, th, td, li, button, input, label, strong, option, textarea'
              )
        : document.querySelectorAll(
              'h1, h2, h3, h4, h5, h6, p, a, address, time, span, th, td, li, button, input, label, strong, option, textarea'
          );

    tags.forEach((item) => {
        if (
            !item.closest('.layout--privacy-policy') &&
            !item.closest('.question_answer__answer') &&
            !item.closest('.specialist_profile__biography') &&
            !item.classList.contains('contacts_block__phone') &&
            !item.classList.contains('attention__license')
        ) {
            const current_font_sz = window.getComputedStyle(item).fontSize.replace('px', '');
            const new_font_sz = current_font_sz * k;
            setFontSize(item, new_font_sz);
        }
    });
};

$(document).ready(() => {
    if (!!localStorage.getItem('is_visually_impaired')) calcFontSize();
});

$('.font-size a').on('click', (e) => {
    const target = $(e.target);
    const body = $('body');
    if (target.hasClass('font-size__item_sm')) {
        body.removeClass('font-size-120');
        body.removeClass('font-size-150');
        body.addClass('font-size-100');
        changeFontSize('1.0');
    } else if (target.hasClass('font-size__item_md')) {
        body.removeClass('font-size-100');
        body.removeClass('font-size-150');
        body.addClass('font-size-120');
        changeFontSize(1.2);
    } else if (target.hasClass('font-size__item_lg')) {
        body.removeClass('font-size-100');
        body.removeClass('font-size-120');
        body.addClass('font-size-150');
        changeFontSize(1.5);
    }
});

$('.font a').on('click', (e) => {
    const target = $(e.target);
    const body = $('body');
    if (target.hasClass('font__item_sans-serif')) {
        localStorage.setItem('font-family', 'sans-serif');
        body.removeClass('serif-font');
        body.addClass('sans-serif-font');
    } else if (target.hasClass('font__item_serif')) {
        localStorage.setItem('font-family', 'serif');
        body.removeClass('sans-serif-font');
        body.addClass('serif-font');
    }
});

$('.letter-spacing a').on('click', (e) => {
    const target = $(e.target);
    const body = $('body');
    if (target.hasClass('letter-spacing__item_sm')) {
        localStorage.setItem('letter-spacing', 'sm');
        body.removeClass('letter-spacing-md');
        body.removeClass('letter-spacing-lg');
        body.addClass('letter-spacing-sm');
    } else if (target.hasClass('letter-spacing__item_md')) {
        localStorage.setItem('letter-spacing', 'md');
        body.removeClass('letter-spacing-sm');
        body.removeClass('letter-spacing-lg');
        body.addClass('letter-spacing-md');
    } else if (target.hasClass('letter-spacing__item_lg')) {
        localStorage.setItem('letter-spacing', 'lg');
        body.removeClass('letter-spacing-sm');
        body.removeClass('letter-spacing-md');
        body.addClass('letter-spacing-lg');
    }
});

$('.line-spacing a').on('click', (e) => {
    const target = $(e.target);
    const body = $('body');
    if (target.hasClass('line-spacing__item_sm')) {
        localStorage.setItem('line-spacing', 'sm');
        body.removeClass('line-spacing-md');
        body.removeClass('line-spacing-lg');
        body.addClass('line-spacing-sm');
    } else if (target.hasClass('line-spacing__item_md')) {
        localStorage.setItem('line-spacing', 'md');
        body.removeClass('line-spacing-sm');
        body.removeClass('line-spacing-lg');
        body.addClass('line-spacing-md');
    } else if (target.hasClass('line-spacing__item_lg')) {
        localStorage.setItem('line-spacing', 'lg');
        body.removeClass('line-spacing-sm');
        body.removeClass('line-spacing-md');
        body.addClass('line-spacing-lg');
    }
});

$('.images-control input').on('change', (e) => {
    const target = $(e.target);
    const check_images = target.is(':checked');

    if (check_images) {
        target.siblings().text('Выкл');
        localStorage.setItem('images-are-disabled', true);
        $('body').addClass('images-are-disabled');
    } else {
        target.siblings().text('Вкл');
        localStorage.removeItem('images-are-disabled', false);
        $('body').removeClass('images-are-disabled');
    }
});
